/* eslint-disable */
export const arrowupIcon = {
  data: `<svg viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.36816 3.91968L4.46396 1.01547L1.55976 3.91968" stroke="currentColor" stroke-width="1.54891" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrowup' as const,
};
